import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=ec0a451a&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=ts&"
export * from "./Cards.vue?vue&type=script&lang=ts&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=ec0a451a&scoped=true&lang=css&"
import style1 from "./Cards.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0a451a",
  null
  
)

export default component.exports